import React from 'react'
import { Main } from './components'

const Shops = () => <Main />

export default Shops
